"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const text_input_1 = require("../text-input");
const lodash_1 = __importDefault(require("lodash"));
function EmailInput({ value, onChange, ...rest }) {
    const [email, setEmail] = (0, react_1.useState)(value);
    const [error, setError] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        return () => {
            debounceSetError.cancel();
        };
    }, []);
    const validateEmail = (emailString) => {
        let valid = false;
        if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(emailString) ||
            emailString === "") {
            valid = true;
        }
        debounceSetError(!valid);
        return valid;
    };
    const debounceSetError = (0, react_1.useCallback)(lodash_1.default.debounce((flag) => {
        setError(flag);
    }, 500), []);
    const handleEmailChange = event => {
        const inputValue = event.target.value;
        setEmail(inputValue);
        if (validateEmail(inputValue)) {
            onChange(inputValue, event);
        }
        else {
            onChange("", event);
        }
    };
    return ((0, jsx_runtime_1.jsx)(text_input_1.TextInput, { ...rest, isError: error, isErrorText: error, helpText: error ? "Please enter an email with a valid format" : undefined, onChange: handleEmailChange, value: email }));
}
exports.EmailInput = EmailInput;
